import { memo } from "react";
import { Box, Icon, Typography } from "@/components";

export const EmptyRedemptionState = memo(function EmptyRedemptionState() {
    return (
        <Box card className="items-center gap-3 px-6 py-8 text-center">
            <Icon name="Info" className="h-12 w-12 text-muted" />
            <div className="space-y-1">
                <Typography variant="h6" className="text-primary">
                    No redemption positions
                </Typography>
                <Typography variant="body2" className="mx-auto max-w-md text-dark">
                    When you request redemptions, they will appear here. You can track their progress through the
                    redemption queue and claim them when they are ready.
                </Typography>
            </div>
        </Box>
    );
});

EmptyRedemptionState.displayName = "EmptyRedemptionState";
